import { SANDOS, MARCONFORT } from './brand';

const CONTACTS = {
  [SANDOS]: [
    { name: context => context.t('USA'), phone: '1 (863) 204-3331' },
    { name: context => context.t('Canada'), phone: '+1 866 941 0851' },
    { name: context => context.t('Argentina'), phone: '0800 333 1086' },
    { name: context => context.t('Brazil'), phone: '(11) 3230-3131' },
    { name: context => context.t('Mexico'), phone: '+52 55 4164 2355' },
    { name: context => context.t('Spain & Europe'), phone: '+34 960 479 446' },
    { name: context => context.t('UK'), phone: '020 3984 9023' },
    { name: context => context.t('Others'), phone: '+525541642355' },
  ],
  [MARCONFORT]: [
    { name: context => context.t('Spain & Europe'), phone: '+34 960 479 447' },
    { name: context => context.t('UK'), phone: '020 3984 9024' },
  ],
}

const SOCIAL_MEDIAS = {
  [SANDOS]: [
    { icon: 'facebook', url: 'https://www.facebook.com/sandoshotels', iconTheme: 'filled' },
    { icon: 'instagram', url: 'https://www.instagram.com/sandoshotels', iconTheme: 'filled' },
    { icon: 'youtube', url: 'https://www.youtube.com/user/SandosHotels', iconTheme: 'filled' },
  ],
  [MARCONFORT]: [
  ],
};


export {
  CONTACTS,
  SOCIAL_MEDIAS,
}
